var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "42px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "48px",
    height: "42px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAqCAQAAABfRhDxAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoAhUUFiQQcJ0oAAACBklEQVRIx+1VPY/TQBB9RidEgfBWiAKRrWiztBTnzT8wEgUFks0viH8Aks+ioAw1zcYnhOiSSHQUjvkDtq9Ms76aAuckJAqkpViMP+JAEI4QkmcKWzs77828Wa8NhbalZEsAwMpxoK1pxgoCsHSUs6IVVDWPqBuQBBIKChKSRm4QUYX9HlF7BvkjQ0FB0sjz6jtqW7mA1MA1V5Bu0A2ekCpjFFuhFZqZziLJmdsiEFxvtULBK4iZPV7phN0+FowkOmPB6uu+q2m4aBCYGeR41SWH4DrWXncCSDPrFnDqQZpZQmoECZl6pVSexwUXXFRtOp0i+W41ORrpql/ZZVkaXjWH/FNVVY55n/6VNzIUJEnqIisY9WNK48tT5OMLewEUZPno8h7gnM/9/Qf0zA18wPpoL1gKLO35s+0t86oY7zmmCRnFdVVnthX+roOp16zYCUpxOjo4hl07Mv4/IfhwfyImIiV/AvP24URMRGdod2znp1BQv76D2v7yCRTk5vpupE+J6IES9WsDwUDw92YorOnKTmsX7Jebnx4Dd97d+Ho4zJZ8toG7b06+VWssc+aswNRr/DD6dem7BqT+AmdP2fv+hJlvwtsAQFKU9Udmn6X7L8oe/v9TNBAMBAPBQHCAnZQv4SZ+3R9s/Fw/zSv47tF+OBJScEMhJWuePshpv9LQnCXeEvgOoalFrkl99rIAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAps);
export default __webpack_public_path__ + "static/media/Aps.975557da8e6908493f772d261c712c77.svg";
export { ForwardRef as ReactComponent };